import createjs from 'preload-js'

class Preloader {

// queue.on("fileload", handleFileComplete);
// queue.loadFile('http://createjs.com/assets/images/png/createjs-badge-dark.png');
// function handleFileComplete(event) {
//   document.body.appendChild(event.result);
// }

  constructor(assets) {

    console.log('assets', assets)

    this.percentageLoaded = 0

    this.queue = new createjs.LoadQueue(false);

    // this.loader = new Loader();

    this.assetManifest = Object.keys(assets).map((key) => {
      return { src: assets[key], id: key }
    })

    this.queue.on('progress', (event) => {
      this.percentageLoaded = event.loaded
    })

    // Add each of the assets for the case study to the loader
    // TODO - These are going to need to be updated each time a new case study is loaded
    // Perhaps load them from a data attribute
    this.queue.loadManifest(this.assetManifest)
  }

  getPercentageLoaded() {
    return this.percentageLoaded
  }

  on(eventName, cb) {
    this.queue.on(eventName, (loader, resource) => {
      cb.call(this, this, resource)
    })
  }

  load() {
    return new Promise((resolve, reject) => {

      this.queue.on('complete', (event) => {

        console.log('the event', event)

        resolve()
      })
    })
  }

  reset() {
    // this.queue.reset()
  }
}

export default Preloader
